import { useEffect } from 'react';

const Authenticated = ({ setState }) => {
  useEffect(() => {
    setState('CONNECTING');
  }, [setState]);
  return <div>Authenticated</div>;
};
export default Authenticated;
